import { IconProps } from "../../utils/global-types/global-types";

const InboxIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.553 4.247c0-.934.758-1.692 1.692-1.692h8.616c.934 0 1.692.758 1.692 1.692v6.154c0 .935-.758 1.692-1.692 1.692H6.068a.77.77 0 0 0-.6.29l-1.435 1.792c-.491.613-1.48.267-1.48-.519zm2.462 4.308c0-.255.206-.462.461-.462h6.154a.462.462 0 1 1 0 .924H5.476a.46.46 0 0 1-.461-.462m.461-2.923a.462.462 0 0 0 0 .923h3.692a.462.462 0 0 0 0-.923z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default InboxIcon;
